import styled from "styled-components";
import { FooterSection, LeadingTitle } from "@components";
import { Table } from "react-bootstrap";
import { useState, useEffect } from "react";
import { DividenAPI, ShortDescriptionAPI } from "@api";
import moment from "moment";
import "./Dividen.scss";
import { useTranslation } from "react-i18next";

const CorporateContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const Dividen = function () {
  const {t} = useTranslation();
  const [dividen, setDividen] = useState();
  const [shortDesc, setShortDesc] = useState(null);

  useEffect(() => {
    const loadDividen = async () => {
      const { data } = await DividenAPI();
      setDividen(data.data.result);
    };

    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "dividen" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }

    if (!dividen) {
      loadDividen();
    }
  }, [dividen, shortDesc]);

  return (
    <CorporateContainer>
      <LeadingTitle
        title="Dividen"
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />

      <div className="dividen-content">
        <Table bordered className="table-striped-custom">
          <thead>
            <tr className="border-0">
              <th className="border-0">No.</th>
              <th className="border-0 text-center">{t("tahun_buku")}</th>
              <th className="border-0 text-center">{t("jumlah")}</th>
              <th className="border-0 text-center">{t("persentase")} (%)</th>
              <th className="border-0 text-center">{t("dividen_per_saham")}</th>
              <th className="border-0 text-center">{t("tanggal_pembayaran")}</th>
            </tr>
          </thead>
          <tbody>
            {!dividen
              ? ""
              : dividen.map((data, i) => {
                  return (
                    <tr className="border-0" key={i}>
                      <td className="border-0">{i + 1}.</td>
                      <td className="border-0 text-center">{data.tahun_buku}</td>
                      <td className="border-0 text-center">{data.jumlah}</td>
                      <td className="border-0 text-center">{data.persentase}</td>
                      <td className="border-0 text-center">{data.dividen_per_saham}</td>
                      <td className="border-0 text-center">
                        {moment(
                          data.tanggal_bayar,
                          "DD-MM-YYYY hh:mm:ss"
                        ).format("DD MMMM YYYY")}
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </Table>
      </div>
      <FooterSection currentPage="Dividen"/>
    </CorporateContainer>
  );
};

export default Dividen;
